import React, { Component } from "react";
import { Link } from "react-router-dom";
import ScrollableAnchor from "react-scrollable-anchor";
import intl from "react-intl-universal";
import { configureAnchors } from "react-scrollable-anchor";
import "../pricing.css";

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isTestPlan: false,
      handle_buy_error: false,
      handle_buy_error_message: "",
      single_user_selected: {
        package_price: "1000",
        package_time: intl.get("pricing_Yearly"),
        package_id: "",
      },
      small_business_selected: {
        package_price: "3400",
        package_time: intl.get("pricing_Yearly"),
        package_id: "",
      },
    };

    configureAnchors({ offset: -200, scrollDuration: 0 });
  }

  componentDidMount() {
    var regExpPlan = /[?&]checkoutPlanId[=]([^&]+)(&|$)/gi;
    var matchPlan = regExpPlan.exec(window.location.search);
    var regExpCheckout = /[?&]checkoutPageId[=]([^&]+)(&|$)/gi;
    var testFlag = window.location.search.match(/[?&]test[=]1/gi) !== null;
    this.setState({ isTestPlan: testFlag });
    var matchCheckout = regExpCheckout.exec(window.location.search);
    if (matchPlan !== null && matchCheckout !== null) {
      this.fetchBuyNow(matchPlan[1], matchCheckout[1]);
    }
  }

  handleBuyNow = (event, planID, checkoutPageId, isFreeTrialSelected) => {
    event.preventDefault();
    this.fetchBuyNow(planID, checkoutPageId, isFreeTrialSelected);
  };

  fetchBuyNow = (planID, checkoutPageId, isFreeTrialSelected) => {
    this.setState({ isLoading: true });

    if (this.props.props.isLoggedIn) {
      var testFlag = window.location.search.match(/[?&]test[=]1/gi) !== null;
      fetch(
        process.env.REACT_APP_API_URL +
          "CheckoutPlan?planId=" +
          planID +
          "&checkoutPageId=" +
          checkoutPageId +
          (testFlag ? "&test=1" : ""),
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.ok) {
            return res;
          } else {
            throw Error(`Request rejected with status ${res.status}`);
          }
        })
        .then((res) => res.json())
        .then((result) => {
          if (result.Result.toLowerCase() === "success") {
            window.location = result.RedirectUrl;
          } else {
            this.setState({ handle_buy_error: true });
            this.setState({ handle_buy_error_message: result.Message });
            this.setState({ isLoading: false });
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.message.includes("401"))
            window.location =
              window.location.origin +
              "/store/signIn/?redirect=" +
              escape(
                "/uavpackages/pricing?checkoutPlanId=" +
                  planID +
                  "&checkoutPageId=" +
                  checkoutPageId
              );
          else this.props.props.handleServerError(true);
        });
    } else {
      if (isFreeTrialSelected) {
        window.location =
          window.location.origin +
          "/store/signUp/?redirect=" +
          escape(
            "/uavpackages/pricing?checkoutPlanId=" +
              planID +
              "&checkoutPageId=" +
              checkoutPageId
          );
      } else {
        window.location =
          window.location.origin +
          "/store/signIn/?redirect=" +
          escape(
            "/uavpackages/pricing?checkoutPlanId=" +
              planID +
              "&checkoutPageId=" +
              checkoutPageId
          );
      }
    }
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div className="cssload-loader cssload-pricingLoader">
          <div className="cssload-square cssload-square--main">
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
          </div>
        </div>
      );
      // return <div className="loader" />;
    }
    return (
      <div className="row no-gutter">
        <ScrollableAnchor id={"pricingHeader"}>
          <div className="container pricingContainer">
            <h3 className="pricing_mini_title">Skyline Online Store - UAV</h3>
            {this.state.handle_buy_error ? (
              <div id="divWarning" style={{ marginBottom: "30px" }}>
                <button
                  id="x"
                  onClick={(event) =>
                    this.setState({ handle_buy_error: false })
                  }
                >
                  X
                </button>
                {this.state.handle_buy_error_message}
              </div>
            ) : null}
            <div className="row">
              <div className="col-md-4 col-sm-6">
                <div className="pricingTable">
                  <h3 className="title" style={{ height: "65px" }}>
                    PhotoMesh UAV
                    <br />
                  </h3>
                  <div className="price-value">
                    <div className="price-value-mount">
                      <span
                        className="amount mt-3"
                        style={{ fontSize: "38px" }}
                      >
                        <span
                          className=""
                          style={{
                            textDecoration: "line-through",
                            left: "-26px",
                          }}
                        >
                          $1500
                        </span>
                        <span className="" style={{ marginLeft: "1em" }}>
                          ${this.state.single_user_selected.package_price}{" "}
                        </span>
                      </span>
                      <span style={{ color: "white" }}>
                        {this.state.single_user_selected.package_time ===
                        intl.get("pricing_Yearly")
                          ? " / Year"
                          : " / Month"}
                      </span>
                    </div>
                  </div>
                  <ul className="pricing-content text-left">
                    <li className="pricing_package_content">PhotoMesh</li>
                    <ul>
                      <li className="sub_packge_content">
                        Outputs: 3DML, Orthophoto, DSM, LAS
                      </li>
                      <li className="sub_packge_content">
                        Up to 10 Gigapixels (500 Photos)
                      </li>
                    </ul>
                    <li className="pricing_package_content">
                      TerraExplorer Plus
                    </li>
                    <li className="pricing_package_content">
                      Online support materials
                    </li>

                    <div className="pricingDivSpace" />
                  </ul>
                  <div>
                    <button
                      onClick={(event) => {
                        if (this.state.isTestPlan)
                          this.handleBuyNow(
                            event,
                            "test-basicuavtrial-k9vda",
                            "5ea0b37e-ec4d-40c3-aea9-35cdd5a34010",
                            true
                          );
                        else
                          this.handleBuyNow(
                            event,
                            "basicuavtrial",
                            "8b856edd-db19-4f17-a780-f7d9714a5b5e",
                            true
                          );
                      }}
                      className="pricingTable-signup pricingTable-WithFreeTrial"
                    >
                      Free 15-day trial
                    </button>
                    <button
                      onClick={(event) => {
                        if (this.state.isTestPlan)
                          this.handleBuyNow(
                            event,
                            "test-basicuav-k9vda",
                            "ba22e09f-db55-4dd2-914f-a619c6079a93"
                          );
                        else
                          this.handleBuyNow(
                            event,
                            "basicuav",
                            "228a7d3a-867c-408b-8f87-4304d8cefc6a"
                          );
                      }}
                      className="pricingTable-signup"
                    >
                      {intl.get("pricing_Buy_Now")}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="pricingTable">
                  <h3 className="title">
                    PhotoMesh UAV <br /> Plus
                  </h3>
                  <div className="price-value">
                    <div className="price-value-mount">
                      <span
                        className="amount mt-3"
                        style={{ fontSize: "38px" }}
                      >
                        <span className="currency" style={{ left: "-26px" }}>
                          $ {"     "}
                        </span>
                        3400
                      </span>
                      <span style={{ color: "white" }}>
                        {this.state.single_user_selected.package_time ===
                        intl.get("pricing_Yearly")
                          ? " / Year"
                          : " / Month"}
                      </span>
                    </div>
                  </div>
                  <ul className="pricing-content text-left">
                    <li className="pricing_package_content">PhotoMesh</li>
                    <ul>
                      <li className="sub_packge_content">
                        Outputs: 3DML, OBJ, OSGB, 3D Tiles,
                        <br />
                        SLPK, Orthophoto, DSM, DTM, LAS
                      </li>
                      <li className="sub_packge_content">Unlimited photos</li>
                    </ul>
                    <li className="pricing_package_content">
                      TerraExplorer Plus
                    </li>
                    <li className="pricing_package_content">
                      Personal support
                    </li>

                    <div className="pricingDivSpace" />
                  </ul>
                  <div>
                    <button
                      onClick={(event) => {
                        if (this.state.isTestPlan)
                          this.handleBuyNow(
                            event,
                            "test-uavplustrial-k9vda",
                            "44112a96-c285-48ac-b0ce-e8114dd78aa9",
                            true
                          );
                        else
                          this.handleBuyNow(
                            event,
                            "UAVPlusTrial",
                            "7b0eca7c-066c-463b-8e85-867eddd5b3c3",
                            true
                          );
                      }}
                      className="pricingTable-signup pricingTable-WithFreeTrial"
                    >
                      Free 15-day trial
                    </button>
                    <button
                      onClick={(event) => {
                        if (this.state.isTestPlan)
                          this.handleBuyNow(
                            event,
                            "test-uavplus",
                            "0d24d6cf-a1db-4ac9-a69c-1eb6223c9830"
                          );
                        else
                          this.handleBuyNow(
                            event,
                            "UAVPlus",
                            "6149b629-35e4-4843-a163-aa4eaa69f010"
                          );
                      }}
                      className="pricingTable-signup"
                    >
                      {intl.get("pricing_Buy_Now")}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="pricingTable">
                  <h3 className="title" style={{ height: "65px" }}>
                    Customized Package <br />
                  </h3>
                  <div
                    className="price-value"
                    style={{ backgroundColor: "#404040" }}
                  >
                    <div className="price-value-mount">
                      <span
                        className="amount mt-3"
                        style={{ fontSize: "30px" }}
                      >
                        Package-Dependent
                      </span>
                    </div>
                  </div>
                  <ul className="pricing-content text-left">
                    <li className="pricing_package_content">
                      Additional PhotoMesh fusers
                    </li>
                    <li className="pricing_package_content">
                      Advanced publishing tools
                    </li>
                    <li className="pricing_package_content">
                      Hosting services
                    </li>
                    <li className="pricing_package_content">
                      Web and mobile viewers
                    </li>
                    <div style={{ height: "133px" }} />
                  </ul>
                  <div>
                    <Link
                      to="/contactUs"
                      className="pricingTable-signup customizeButton"
                    >
                      CONTACT US
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="FAQ_Pricing">
              <h3>What is included in each of the packages?</h3>
              <p>
                PhotoMesh UAV combines a photogrammetry processing (PhotoMesh)
                license to create 2D/3D models from your images and a
                visualization software (TerraExplorer Plus) license to view,
                analyze, and enhance your projects. The PhotoMesh UAV level
                incorporates up to 500 photos (assuming a 20MP camera) per
                project and will create a 2D file (Orthophoto, in GeoTIFF
                format), a Digital Surface Model (DSM), a 3D point cloud (LAS)
                and a 3D Mesh (3DML format). For customers that have larger
                projects or need other industry standard output formats, we
                offer the PhotoMesh UAV Plus package. It includes one PhotoMesh
                license which can process unlimited photos per project and a
                visualization software (TerraExplorer Plus) license. In addition
                to unlimited photos, the Plus level provides a selection of
                industry standard output formats such as ESRI I3S and SLPK,
                Cesium 3D Tiles, OSGB and OBJ (CAD) files.
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>How much do the packages cost?</h3>
              <p>
                The PhotoMesh UAV package costs $1000 per year. We accept all
                major credit cards. Please email us at{" "}
                <a href="mailto:photomeshuav@skylinesoft.com">
                  photomeshuav@skylinesoft.com
                </a>{" "}
                if you (or your company) require traditional invoicing and
                billing before purchasing an eval or license through this store.
                If you are a Yuneec UAV customer, we also provide a training
                dataset, a Yuneec specific training video and 1 free
                consultation. We offer a 15-day evaluation license for free.
                Customers must provide a credit card to start their evaluation
                license. Unless a customer cancels their subscription, billing
                will occur automatically on the 16th day after receipt of the
                eval license. The PhotoMesh UAV Plus package costs $3400 per
                year. Customers may apply a prorated credit of their PhotoMesh
                UAV package to upgrade to the Plus package at anytime during the
                1 year subscription. Upgrades are available upon email request
                at{" "}
                <a href="mailto:photomeshuav@skylinesoft.com">
                  photomeshuav@skylinesoft.com
                </a>{" "}
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>Which package is right for me?</h3>
              <p>
                Users who only need to view the 3D result in TerraExplorer and
                do not have large projects can start with the regular package.
                If you need to build larger projects or produce output in
                additional formats, select the PhotoMesh UAV Plus package.
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>What kind of drone is PhotoMesh UAV compatible with?</h3>
              <p>
                PhotoMesh UAV is designed to work with almost any drone camera
                (in photo or video mode). We have tested and guarantee full
                operational compatibility with all Yuneec payload options.
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>Can I try PhotoMesh UAV for free?</h3>
              <p>
                Yes! We are happy to provide a free 15 day trial of PhotoMesh
                UAV. We ask that you reserve your trial with a credit card. We
                will notify you via email when the trial period is ending. If
                you decide to terminate the package before it expires, your
                credit card will not be charged.{" "}
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>What happens when my subscription is over?</h3>
              <p>
                You will receive notification via email when your subscription
                period is ending. If you don’t decide to terminate your package,
                it will be automatically renewed to ensure no lapse in services.
                You can also turn off the auto-renew option at any time during
                your service period and we will automatically terminate your
                license when the period is over.{" "}
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>
                Can I upgrade or downgrade my package in the middle of a
                subscription?
              </h3>
              <p>
                Yes, if your data needs change, you can gladly{" "}
                <a href="mailto:support@skylinesoft.com">contact us</a> and we
                will help you modify your PhotoMesh UAV package accordingly.
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>Do I need an Internet connection?</h3>
              <p>
                Generally, yes, you need to be connected to the Internet to run
                PhotoMesh and TerraExplorer, since these applications need to
                “check in” periodically with the license server. If, however,
                you need to work offline, this also can be arranged. To do so,{" "}
                <a href="mailto:support@skylinesoft.com">contact us</a> after
                completing the online purchase, and we will help you with the
                setup process.
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>Can I share my output with others?</h3>
              <p>
                If you are interested in data hosting and sharing your data with
                remote TerraExplorer clients as well as Esri, Cesium, and other
                GIS clients,{" "}
                <a href="mailto:suppot@skylinesoft.com">contact us</a> for
                information about advanced packages that include these
                capabilities.
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>What is PhotoMesh?</h3>
              <p>
                Skyline’s PhotoMesh application fully automates the building of
                high-resolution, textured, 3D mesh models from your drone
                photos. PhotoMesh’s breakthrough technology is based on the
                highest-performance photogrammetry, computer vision, and
                computational geometry algorithms. PhotoMesh results can be
                generated in standard 3D model (3DML, 3D Tiles, DAE, OBJ, OSGB,
                I3S/SLPK), raster (Orthophoto, DSM, DTM) and point cloud (LAS)
                formats. The 3DML format can be transformed into powerful
                geospatial data that fully supports spatial operations and
                attribute queries, by loading it into TerraExplorer and merging
                it with classification information.{" "}
                <a href="https://support.skylinesoft.com/hc/en-us/articles/360013640840-Create-a-New-PhotoMesh-Project-and-Add-Photos-to-the-Project">
                  Get started with PhotoMesh >
                </a>
              </p>
            </div>
            <div className="FAQ_Pricing">
              <h3>What is TerraExplorer Plus?</h3>
              <p>
                TerraExplorer Plus is a powerful GIS tool for merging your mesh
                models with unlimited, geo-referenced 3D terrain, Lidar, BIM,
                raster and feature layers into a 3D high-resolution, geospatial
                environment. TerraExplorer Plus also provides powerful tools and
                a high resolution 3D environment in which to view, query,
                analyze and present geospatial data plus advanced API
                interfaces.{" "}
                <a href="https://support.skylinesoft.com/hc/en-us/articles/360014436079-Quick-Guide">
                  Get started with TerraExplorer >
                </a>
              </p>
            </div>
            <div className="contact_Us_Pricing">
              <h3>
                {intl.get("FAQ_Contact_US_Title")}{" "}
                <Link
                  to="/contactUs"
                  className="btn btn-outline-primary text-capitalize"
                >
                  {" "}
                  {intl.get("FAQ_Contact_Us")}
                </Link>
              </h3>
            </div>
            <div className="bottom_Spacing" />
          </div>
        </ScrollableAnchor>
      </div>
    );
  }
}

export default Pricing;
